import { render, staticRenderFns } from "./CategoriesModule.vue?vue&type=template&id=9775a776&scoped=true"
import script from "./CategoriesModule.vue?vue&type=script&lang=js"
export * from "./CategoriesModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9775a776",
  null
  
)

export default component.exports